module.exports = __webpack_public_path__ + "static/img/bg-three-pineapple.b7fd55a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-three-pineapple.png
// module id = 47
// module chunks = 0